import React, { useState } from 'react';
import { NavigationSidebar } from '../components/NavigationSidebar';
import { MobileMenu } from '../components/MobileMenu';
import { EventModal } from '../components/EventModal';
import { motion } from 'framer-motion';
import { Calendar, Clock, MapPin, Users, ArrowLeft } from 'lucide-react';
const DINNERS = [{
  city: 'The Invisible Structures That Shape Our Lives',
  location: 'Chiang Mai, Thailand',
  date: '3 FEB 2026',
  desc: 'Residency dinner series',
  link: 'https://www.altcoliving.com/food-that-nourishes-us-residency/',
  image: 'https://cdn.magicpatterns.com/uploads/3X9TLZUDybLFDUXCx3mGdv/Screenshot_2026-01-20_at_5.04.57_PM.png',
  about: "Join us for an intimate evening exploring the hidden frameworks that guide our choices, relationships, and sense of belonging. Through thoughtful conversation over a carefully curated meal, we'll examine how invisible social structures shape our lives as nomads and travelers.",
  hosts: 'Hosted by Annissa Poon and Chef Mihn, longtime nomads and community builders who have facilitated gatherings across 30+ countries.'
}, {
  city: 'The Archipelago Life',
  location: 'Hong Kong',
  date: '9 FEB 2026',
  desc: 'Collective Table gathering',
  link: 'https://luma.com/viarx0j7',
  image: 'https://cdn.magicpatterns.com/uploads/twXB3kmZmS464MLKc9NuRP/0_2-2.png',
  about: "An evening celebrating the beauty of living between worlds—island hopping through life, culture, and identity. We'll share stories of belonging to multiple places while being rooted in none, over dim sum and Hong Kong's finest tea.",
  hosts: 'Hosted by Annissa Poon, a Hong Kong native and third-culture storyteller who curates meaningful connections across Asia.'
}, {
  city: 'Reinventing yourself in a new city',
  location: 'Amsterdam, Netherlands',
  date: '19 FEB 2026',
  desc: 'Dutch canal district gathering',
  link: 'https://luma.com/viarx0j7',
  image: 'https://cdn.magicpatterns.com/uploads/vzDF2obhLo6nbshyxEsBVp/Screenshot_2026-01-20_at_1.36.25_PM.png',
  about: 'Every new city offers a chance to become someone new. Join us for an evening exploring identity, transformation, and the courage it takes to reinvent yourself in unfamiliar places. Featuring Dutch-Indonesian fusion cuisine.',
  hosts: 'Hosted by Emma van der Berg, a serial expat who has reinvented herself in 7 countries over the past decade.'
}, {
  city: 'Travelling with intention',
  location: 'Taipei, Taiwan',
  date: '22 FEB 2026',
  desc: 'Island gathering',
  link: '#',
  image: 'https://cdn.magicpatterns.com/uploads/wugQCnVKSmo4JhdC35Ptn8/0_0-10.jpg',
  about: 'For those who feel split between two worlds—exploring what it means to carry multiple homes in your heart. An intimate dinner celebrating dual belonging over Taiwanese night market-inspired dishes.',
  hosts: 'Hosted by Amy Huang, a Taiwanese-American writer exploring themes of diaspora and belonging.'
}, {
  city: 'What kind of life am I building toward?',
  location: 'Ping River, Thailand',
  date: '25 FEB 2026',
  desc: 'Northern Thailand meetup',
  link: '#',
  image: 'https://cdn.magicpatterns.com/uploads/nSEk6EoKMCAf9bWQpRrtnX/0_0-8.jpg',
  about: 'A reflective evening by the Ping River, exploring the tension between freedom and stability, movement and roots. What are we building as we move through the world? Featuring authentic Northern Thai cuisine.',
  hosts: 'Hosted by Kai Nakamura, a digital nomad and life design coach based in Chiang Mai.'
}, {
  city: 'What Stability Means to Me',
  location: 'Lisbon, Portugal',
  date: '7 MAR 2026',
  desc: 'European coastal meetup',
  link: '#',
  image: 'https://cdn.magicpatterns.com/uploads/qvqb74jvzSGuaidbs4zLZ5/Screenshot_2026-01-20_at_5.28.27_PM.png',
  about: 'Redefining stability beyond traditional anchors—exploring how nomads create consistency, routine, and emotional grounding while in constant motion. Featuring Portuguese coastal cuisine.',
  hosts: 'Hosted by João Silva, a Lisbon local who has hosted travelers and nomads for over 15 years.'
}, {
  city: 'Making money from anywhere',
  date: '8 MAR 2026',
  desc: 'Bali, Indonesia',
  link: '#',
  image: 'https://cdn.magicpatterns.com/uploads/fkMDKkiknGnncmfHDwk4Ri/0_3-8.jpg',
  about: 'A practical and philosophical exploration of location-independent income—the freedom it creates, the challenges it brings, and how it reshapes our relationship with work and place.',
  hosts: 'Hosted by Priya Sharma, a remote work consultant and digital nomad entrepreneur.'
}, {
  city: 'My Choice of Nomadism',
  location: 'Rio de Janeiro, Brazil',
  date: '18 MAR 2026',
  desc: 'South American connection',
  link: '#',
  image: 'https://cdn.magicpatterns.com/uploads/aDMrk72uQiRYiRVUuge6ij/Screenshot_2026-01-20_at_11.19.15_PM.png',
  about: 'An evening celebrating the intentionality behind choosing a nomadic life—the trade-offs, the rewards, and the moments that make it all worthwhile. Featuring Brazilian churrasco and caipirinhas.',
  hosts: 'Hosted by Lucas Ferreira, a Brazilian nomad who has been traveling continuously for 8 years.'
}, {
  city: 'The Person I Am in Different Cities',
  location: 'Warsaw, Poland',
  date: '24 MAR 2026',
  desc: 'Central European table',
  link: '#',
  image: 'https://cdn.magicpatterns.com/uploads/vzDF2obhLo6nbshyxEsBVp/Screenshot_2026-01-20_at_1.36.25_PM.png',
  about: 'How do different places bring out different versions of ourselves? An exploration of identity fluidity, cultural adaptation, and the many selves we carry. Featuring modern Polish cuisine.',
  hosts: 'Hosted by Anna Kowalski, a Polish cultural anthropologist and community organizer.'
}, {
  city: 'Digital Countries and Tribes',
  location: 'Cannes, France',
  date: '30 MAR 2026',
  desc: 'French Riviera gathering',
  link: '#',
  image: 'https://cdn.magicpatterns.com/uploads/cNUWSNgMQmQakrswn8gabp/Screenshot_2026-01-20_at_9.52.34_PM.png',
  about: 'In an age of digital communities and remote work, are we forming new kinds of countries? An evening exploring online tribes, digital citizenship, and belonging beyond borders.',
  hosts: 'Hosted by Sophie Laurent, a French tech entrepreneur and community architect.'
}];
export function DinnersPage() {
  const [selectedDinner, setSelectedDinner] = useState<(typeof DINNERS)[0] | null>(null);
  const handleRegisterClick = (e: React.MouseEvent, dinner: (typeof DINNERS)[0]) => {
    if (dinner.link === '#') return;
    e.preventDefault();
    setSelectedDinner(dinner);
  };
  return <div className="min-h-screen w-full relative overflow-x-hidden" style={{
    background: 'linear-gradient(to bottom, #F5F0E8 0%, #EFE9DD 50%, #E8DCC8 100%)'
  }} data-id="element-193">
      {/* Fonts import */}
      <style data-id="element-194">{`
        @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,400;0,700;1,400;1,700&family=Space+Mono:ital,wght@0,400;0,700;1,400&family=Young+Serif&display=swap');
        
        .font-mono { font-family: 'Space Mono', monospace; }
        .font-serif { font-family: 'Young Serif', serif; }
        .font-editorial { font-family: 'Playfair Display', serif; }
      `}</style>

      {/* Feather decoration in top right corner */}
      <img src="https://cdn.magicpatterns.com/uploads/h6mUMBzdbsDJJ9AUacnPNR/feather.png" alt="" className="fixed right-0 top-0 w-64 md:w-80 h-auto pointer-events-none" style={{
      zIndex: 5,
      opacity: 0.9
    }} data-id="element-195" />

      <div className="relative z-10 flex min-h-screen" data-id="element-196">
        {/* Mobile Menu - Only visible on mobile */}
        <MobileMenu data-id="element-197" />

        {/* Desktop Navigation - Hidden on mobile */}
        <div className="hidden md:block" data-id="element-198">
          <NavigationSidebar data-id="element-199" />
        </div>

        <main className="flex-1 p-4 py-12" data-id="element-200">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          ease: 'easeOut'
        }} className="relative w-full max-w-6xl mx-auto" data-id="element-201">
            <div className="w-full space-y-6" data-id="element-202">
              <div className="flex items-start justify-between gap-4" data-id="element-203">
                <div data-id="element-204">
                  <h1 className="text-2xl md:text-3xl font-bold mb-6 tracking-tight text-left" style={{
                  fontFamily: "'Fette Fraktur', cursive",
                  color: '#2D4A4F'
                }} data-id="element-205">
                    Upcoming Dinners
                  </h1>
                  <p className="text-sm leading-relaxed max-w-2xl font-sans text-left" style={{
                  color: '#4B5563'
                }} data-id="element-206">
                    Join us at our upcoming events around the world. We bring
                    together builders, thinkers, and creators for evenings of
                    meaningful conversation and connection.
                  </p>
                </div>

                <a href="/" className="flex items-center gap-2 text-sm font-medium hover:underline whitespace-nowrap mt-1" style={{
                color: '#2D4A4F'
              }} data-id="element-207">
                  <ArrowLeft size={16} data-id="element-208" />
                  Back
                </a>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4 mt-8" data-id="element-209">
                {DINNERS.map((dinner, index) => {
                // Extract host name from hosts field
                const hostName = dinner.hosts.match(/Hosted by ([^,]+)/)?.[1] || 'Unknown Host';
                return <motion.div key={index} initial={{
                  opacity: 0,
                  y: 20
                }} animate={{
                  opacity: 1,
                  y: 0
                }} transition={{
                  delay: index * 0.05,
                  duration: 0.3
                }} whileHover={{
                  y: -4,
                  boxShadow: '6px 8px 16px rgba(0, 0, 0, 0.12)',
                  transition: {
                    duration: 0.2,
                    ease: 'easeOut'
                  }
                }} className="relative border-[3px] border-black rounded-2xl flex flex-col overflow-hidden cursor-pointer" style={{
                  backgroundColor: '#C5DDD8'
                }} data-id="element-210">
                      {/* Date badge - absolute positioned in top right */}
                      <div className="absolute top-4 right-4 z-10" data-id="element-211">
                        <span className="px-3 py-1.5 text-xs font-bold border-2 border-black rounded-full" style={{
                      backgroundColor: '#E5D68A'
                    }} data-id="element-212">
                          {dinner.date}
                        </span>
                      </div>

                      {/* Image - Top horizontal */}
                      <div className="w-full h-40 flex-shrink-0 overflow-hidden" data-id="element-213">
                        <img src={dinner.image} alt={`${dinner.city} dinner`} className="w-full h-full object-cover" style={dinner.city === 'What kind of life am I building toward?' ? {
                      transform: 'scale(1.10)'
                    } : dinner.city === 'The Invisible Structures That Shape Our Lives' ? {
                      transform: 'scale(1.05)',
                      objectPosition: 'center 20%'
                    } : dinner.city === 'The Archipelago Life' ? {
                      transform: 'scale(1.05)',
                      objectPosition: 'center 60%'
                    } : dinner.city === 'What Stability Means to Me' ? {
                      objectPosition: 'center 70%'
                    } : undefined} data-id="element-214" />
                      </div>

                      {/* Content - Below image */}
                      <div className="flex-1 p-5 flex flex-col" data-id="element-215">
                        <h3 className="text-lg font-bold mb-1 line-clamp-2" style={{
                      fontFamily: "'Playfair Display', serif",
                      fontStyle: 'italic',
                      fontWeight: 700,
                      color: '#2D4A4F'
                    }} data-id="element-216">
                          {dinner.city}
                        </h3>

                        <p className="text-xs mb-2" style={{
                      color: '#5A6F73'
                    }} data-id="element-217">
                          By {hostName}
                        </p>

                        <p className="text-sm leading-relaxed mb-3 line-clamp-2" style={{
                      color: '#2D4A4F'
                    }} data-id="element-218">
                          {dinner.about}
                        </p>

                        {/* Metadata with icons */}
                        <div className="space-y-1 mb-3" data-id="element-219">
                          <div className="flex items-center gap-2 text-xs" style={{
                        color: '#2D4A4F'
                      }} data-id="element-220">
                            <Calendar size={14} data-id="element-221" />
                            <span data-id="element-222">{dinner.date}</span>
                          </div>
                          {dinner.location && <div className="flex items-center gap-2 text-xs" style={{
                        color: '#2D4A4F'
                      }} data-id="element-223">
                              <MapPin size={14} data-id="element-224" />
                              <span data-id="element-225">{dinner.location}</span>
                            </div>}
                        </div>

                        {/* View Details button */}
                        {dinner.link !== '#' ? <button onClick={e => handleRegisterClick(e, dinner)} className="text-sm font-medium hover:underline mt-auto self-start" style={{
                      color: '#2D4A4F'
                    }} data-id="element-226">
                            View Details
                          </button> : <span className="text-xs text-gray-500 mt-auto cursor-not-allowed" data-id="element-227">
                            Coming Soon
                          </span>}
                      </div>
                    </motion.div>;
              })}
              </div>
            </div>
          </motion.div>
        </main>
      </div>

      <EventModal isOpen={selectedDinner !== null} onClose={() => setSelectedDinner(null)} dinner={selectedDinner} data-id="element-228" />
    </div>;
}